let baseConfig: BaseConfig = {
    // cm换算px比例
    cmProportion: 4,

    //FRONT(0, "正面"),LEFT(1, "左面"),RIGHT(2,"右面"),BACK(3,"背面"),TOP(4,"上面");
    renderFace: 0,

    // 流动线速度 [1, 100)
    borderSpeed: 50,

    // 流动线间隔
    borderSpace: 5,

    // 流动线宽度
    borderWidth: 1,

    // 商家id
    venderId: -999,

    // http mock
    useMock: false,

    // 移动步长
    moveStep: 1,

    // 0:老版本权限，1:新版本权限，2：新老版本共同拥有
    auth: 0,

    // 图纸id
    paperId: -1,

    // 历史记录最大值
    historyMaxStepCount: 10,

    // 版本
    version: 'v2.0.1',

    // 最大选择动效cube数目
    maxFlowCubesCount: 110
};

export default baseConfig;
